{
  "common": {
    "next": "Next",
    "previous": "Previous",
    "cancel": "Cancel",
    "save": "Save",
    "reset": "Reset",
    "close": "Close"
  },

  "nav": {
    "home": "Home",
    "about": "About Us",
    "faq": "FAQ",
    "contact": "Contact",
    "order": "Order Now",
    "orderStatus": "Order Status",
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "delivery": "Delivery Information"
  },

  "footer": {
    "tagline": "Premium Blueberries grown with love and passion since 1994.",
    "links": "Links",
    "contact": "Contact",
    "hours": "Opening Hours",
    "weekdays": "Monday - Friday:",
    "saturday": "Saturday:",
    "sunday": "Sunday:",
    "harvestSeason": "Harvest season: July - September",
    "rights": "© 2026 BorowkaSzczecin. All rights reserved."
  },

  "cookie": {
    "message": "This site uses cookies to ensure the best possible service. By using the site, you agree to their use. More information can be found in our",
    "privacyPolicy": "Privacy Policy",
    "decline": "Decline",
    "accept": "Accept"
  },

  "hero": {
    "title": "Fresh",
    "titleHighlight": "Blueberries",
    "subtitle": "Fresh, juicy, and sweet blueberries straight from the field – order today and enjoy the taste of summer!",
    "orderNow": "Order Now",
    "explorePlantation": "Explore Plantation"
  },

  "about": {
    "sectionTitle": "Our Blueberry Plantation",
    "sectionSubtitle": "Since 1994, we have grown highbush blueberries with passion and commitment to quality.",
    "historyTitle": "Our Story",
    "historyP1": "For nearly three decades, we have been growing blueberries on our family farm. What started as a small farm has grown into a renowned plantation known for exceptional care for the quality and taste of its fruit.",
    "historyP2": "We are proud of our sustainable farming practices, combining nature with modern technological solutions that allow us to grow healthy, delicious, nutrient-rich fruit. Every punnet of our blueberries goes through rigorous quality control, so only fruit of the highest quality reaches you.",
    "premiumQuality": "Premium Quality",
    "premiumQualityDesc": "Hand-picked blueberries",
    "organic": "100% Freshness",
    "organicDesc": "Fruit delivered on the day it is picked",
    "bestTaste": "Best Taste",
    "bestTasteDesc": "Rich in antioxidants and intense aroma",
    "customerFavourite": "Customer Favourite",
    "customerFavouriteDesc": "Rated {rating}★"
  },

  "howToOrder": {
    "title": "How to Place an Order?",
    "subtitle": "It's simple.",
    "step1": "Click the {button} button.",
    "step2": "Choose your delivery method: {delivery} or {pickup} at the plantation.",
    "step3": "Enter your personal details, delivery address and payment method.",
    "step4": "Await your delivery soon.",
    "orderNow": "Order Now"
  },

  "whyUs": {
    "title": "Why our blueberries?",
    "natural": "Natural Farming",
    "naturalDesc": "Straight from peatland, mulched with wood chips",
    "local": "Local Production",
    "localDesc": "Support a small farm in your region.",
    "direct": "Straight from the Field",
    "directDesc": "Blueberries are hand-picked and immediately packed.",
    "health": "Health & Taste",
    "healthDesc": "Rich in antioxidants and intense aroma."
  },

  "reviews": {
    "title": "Customer Reviews",
    "summary": "{rating} \u2605 \u00b7 {count} reviews",
    "previous": "Previous review",
    "next": "Next review",
    "goTo": "Go to review {index}"
  },

  "faq": {
    "title": "FAQ",
    "subtitle": "Here you'll find answers to your questions.",
    "priceUnavailable": "The current blueberry price is available in the order form and by phone.",
    "items": [
      {
        "question": "What are the blueberry prices?",
        "answer": "Blueberries are packed in 1 kg cardboard boxes. Current price is {price} PLN per kg."
      },
      {
        "question": "How long does delivery take?",
        "answer": "We try to deliver every day, usually in the evenings."
      },
      {
        "question": "Are the blueberries frozen?",
        "answer": "No, our blueberries are fresh \u2013 we pick and pack them by hand on the same day."
      },
      {
        "question": "What is self-picking?",
        "answer": "Self-picking is the option for customers to pick blueberries themselves at the plantation."
      },
      {
        "question": "When will self-picking start?",
        "answer": "Self-picking starts in the second half of July and runs until the end of August."
      }
    ]
  },

  "gallery": {
    "title": "Gallery",
    "imageAlt": "Blueberry plantation"
  },

  "localization": {
    "title": "Where to Find Us?",
    "subtitle": "Our plantation is located in Pilchowo"
  },

  "contact": {
    "title": "Contact",
    "message": "Have questions? Write to us:",
    "or": "or call:"
  },

  "thankyou": {
    "title": "Thank you for your order!",
    "subtitle": "Your order has been received and is being processed.",
    "paymentPaidTitle": "Thank you for your payment!",
    "paymentPaidSubtitle": "Your payment has been confirmed and your order is being processed.",
    "paymentPendingTitle": "Waiting for payment confirmation",
    "paymentPendingSubtitle": "Your order has been saved. We are waiting for payment confirmation from Autopay.",
    "paymentFailedTitle": "Payment failed",
    "paymentFailedSubtitle": "Your order has been saved, but the payment was not confirmed. Check your email inbox, where Autopay may send more information.",
    "checkingOrderTitle": "Checking your order",
    "checkingOrderSubtitle": "We are fetching the latest order and payment status.",
    "orderNotFoundTitle": "We could not find this order",
    "orderNotFoundSubtitle": "We cannot confirm this order. Check the link or the confirmation email.",
    "orderId": "Order ID:",
    "goHome": "Go to Homepage",
    "trackTitle": "Track your order",
    "trackText": "You can check your order status at any time. We also sent the link to your email.",
    "trackButton": "Check order status",
    "facebookTitle": "Stay in touch",
    "facebookText": "Follow us on Facebook so you don't miss any updates.",
    "facebookButton": "Visit our Facebook"
  },

  "orderStatus": {
    "title": "Order status",
    "subtitle": "Check the current status of your order.",
    "lookupLabel": "Order number",
    "lookupPlaceholder": "Enter your order number",
    "lookupButton": "Check",
    "loading": "Fetching order status...",
    "emptyPrompt": "Enter your order number to check its status.",
    "notFound": "We couldn't find an order with that number.",
    "error": "We couldn't fetch the order status. Please try again later.",
    "orderId": "Order number",
    "orderedOn": "Order date",
    "preferredDate": "Preferred time",
    "items": "Ordered products",
    "quantityUnit": "kg",
    "backHome": "Back to homepage",
    "steps": {
      "Pending": "Received",
      "Processing": "Processing",
      "Shipped": "On its way",
      "Delivered": "Delivered"
    },
    "stepDescriptions": {
      "Pending": "Your order has been received and is awaiting confirmation.",
      "Processing": "We are preparing your order.",
      "Shipped": "Your order is on its way to you.",
      "Delivered": "Your order has been delivered."
    },
    "pickupSteps": {
      "Shipped": "Ready for pickup",
      "Delivered": "Picked up"
    },
    "pickupStepDescriptions": {
      "Shipped": "Your order is ready for pickup.",
      "Delivered": "Your order has been picked up."
    },
    "statusLabels": {
      "Pending": "Received",
      "Processing": "Processing",
      "Shipped": "On its way",
      "Delivered": "Delivered",
      "Cancelled": "Cancelled",
      "Returned": "Returned"
    },
    "cancelledText": "This order has been cancelled. Please contact us if you have any questions.",
    "returnedText": "This order has been returned. Please contact us if you have any questions."
  },

  "notFoundView": {
    "title": "Page not found",
    "subtitle": "The page you are looking for does not exist or has been moved.",
    "goHome": "Back to homepage"
  },

  "orderView": {
    "title": "Place an Order",
    "subtitle": "Fill in the form and order delicious blueberries.",
    "next": "Next",
    "recaptchaFailed": "reCAPTCHA verification failed.",
    "formSuccess": "Your order has been placed successfully!",
    "formErrors": "Form contains errors",
    "formErrorsDesc": "Please fill in all required fields correctly.",
    "blikCodeMissing": "Enter the BLIK code to pay for the order.",
    "blikPaymentRejected": "BLIK payment was not confirmed",
    "blikPaymentRejectedDesc": "Check the code in your banking app and try again.",
    "previousBlikPaymentSucceeded": "The previous BLIK payment attempt succeeded",
    "previousBlikPaymentSucceededDesc": "We did not start a new payment."
  },

  "seasonGate": {
    "before_start": {
      "title": "Blueberry season has not started yet",
      "description": "The blueberries are still ripening, and blueberry season will begin soon.",
      "facebookCta": "If you want to follow the latest updates, visit our Facebook {facebook}"
    },
    "after_end": {
      "title": "Blueberry season has ended",
      "description": "Thank you for this season. Orders will be available again next season."
    }
  },

  "checkoutView": {
    "title": "Order Summary",
    "subtitle": "Check the accuracy of your data.",
    "blueberry": "Blueberry",
    "back": "Back",
    "submitting": "Placing order...",
    "redirecting": "Redirecting to payment...",
    "processingPayment": "Processing payment...",
    "submit": "Place Order",
    "payOnline": "Pay",
    "pay": "Pay",
    "blikDialogTitle": "Enter BLIK code",
    "blikDialogDescription": "Generate a code in your banking app and enter it below.",
    "blikConfirmTitle": "Confirm the payment in your bank",
    "blikConfirmDescription": "Check your banking app and approve the BLIK payment.",
    "cancelBlikTitle": "Interrupt BLIK payment?",
    "cancelBlikDescription": "We will stop waiting for confirmation. You can enter a new BLIK code and try again.",
    "cancelBlikContinue": "Keep waiting",
    "cancelBlikConfirm": "Interrupt",
    "blikCodeLabel": "BLIK code",
    "blikCodeHelp": "Enter the 6-digit code from your banking app.",
    "blikCodeRequired": "Enter a valid 6-digit BLIK code."
  },

  "termsCheckbox": {
    "accept": "I accept the terms and conditions",
    "andPrivacy": "and the store's privacy policy.",
    "required": "(required)",
    "mustAccept": "You must accept the terms and conditions."
  },

  "termsView": {
    "title": "Terms & Conditions",
    "subtitle": "Terms of Service of the Online Store of Agricultural Farm Mateusz Wdowiak.",
    "download": "Download terms (.docx)"
  },

  "privacyView": {
    "title": "Privacy Policy",
    "subtitle": "Personal data processing rules for the borowkaszczecin.pl online store.",
    "download": "Download privacy policy (.docx)"
  },

  "deliveryView": {
    "infoText": "If you are not sure whether your location is within our delivery zone, please contact us before placing your order.",
    "contactText": "If in doubt, contact us at xxx or via social media.",
    "mapTitle": "Delivery Area Map",
    "locationsTitle": "Serviced Locations",
    "locationsDescription": "Below you will find a list of locations covered by delivery. Number of locations: {count}.",
    "searchPlaceholder": "Search location...",
    "noResults": "No matching location found."
  },

  "order": {
    "create": "Create New Order",
    "createDescription": "Create an Order. Click save when you're done.",
    "typeDelivery": "Delivery",
    "typePickup": "Pickup",
    "cardTitles": {
      "personalData": "Personal Data",
      "deliveryAddress": "Delivery Address",
      "driver": "Driver",
      "deliveryTime": "Delivery Time",
      "paymentStatus": "Payment Status",
      "status": "Order Status",
      "pickupTime": "Pickup time",
      "product": "Product",
      "payment": "Payment Method",
      "note": "Order Notes",
      "details": "Order Details"
    },
    "calendar": {
      "prevMonth": "Previous month",
      "nextMonth": "Next month"
    },
    "formLabels": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "phoneNumber": "Phone Number",
      "email": "Email",
      "localization": "Location Type",
      "localizationPlaceholder": "Select Location Type",
      "street": "Street",
      "buildingNumber": "Building Number",
      "apartmentNumber": "Apartment Number",
      "postalCode": "Postal Code",
      "city": "City",
      "district": "District",
      "driverAddressNote": "Driver note assigned to the address",
      "driverAddressNotePlaceholder": "Enter information useful for the delivery",
      "asFastAsPossible": "As soon as possible",
      "or": "or",
      "preferredTime": "Preferred delivery time:",
      "deliveryDate": "Delivery date:",
      "pickupTime": "Pickup time:",
      "pickupDate": "Pickup date:",
      "chooseDate": "Choose date",
      "today": "Today",
      "hour": "Hour",
      "minute": "Minute",
      "product": "Product",
      "quantity": "Quantity",
      "card": "BLIK",
      "autopay": "Autopay",
      "cash": "Cash",
      "paymentStatus": "Payment Status",
      "status": "Order Status",
      "notePlaceholder": "Gate code, watch out for dog",
      "priceUnit": "PLN / pc.",
      "currencyUnit": "PLN",
      "subtotal": "Subtotal",
      "delivery": "Delivery",
      "tax": "Tax",
      "total": "Total"
    },
    "checkout": {
      "pickupTime": "Pickup date",
      "deliveryTime": "Preferred delivery time",
      "contactData": "Contact details",
      "customerData": "Full name"
    },
    "similarOrders": {
      "title": "Similar orders",
      "description": "Choose one to prefill customer and address data.",
      "startTyping": "Start typing customer or address fields to search for similar orders.",
      "searching": "Searching...",
      "empty": "No similar orders found for current input.",
      "select": "Select",
      "noDeliveryAddress": "No delivery address",
      "lastOrder": "Last order: {date}"
    },
    "info": {
      "deliveryInfo": "Delivery Information",
      "deliverySameDay": "If the order is placed in the morning and you choose the \"as soon as possible\" option, same-day delivery may be available.",
      "deliveryRainInfo": "Please note that in the case of heavy rainfall, a delay may occur. In that case, we will inform you of the change in delivery date.",
      "pickupInfo": "Pick-up Information",
      "pickupHours": "Pick-up is available between 10:00 and 18:00.",
      "deliveryTimeInfo": "Delivery Time Information",
      "deliveryTimeDetails": "Home deliveries usually take place between 17:00 and 22:00. We try to deliver the fruit as quickly as possible. The blueberries we deliver come from the same day's harvest, so we depend on the amount of fruit picked and on weather conditions, such as rainfall, which can make harvesting impossible. For this reason, please note that the delivery date may change.",
      "paymentInfo": "Payment Information",
      "cashOnly": "Online payments are handled by Autopay. You can choose BLIK, Autopay, or cash on delivery.",
      "morePaymentsSoon": "After choosing BLIK, enter the code from your banking app in the order summary.",
      "sorryForInconvenience": "We apologise for the inconvenience and thank you for your understanding.",
      "deliveryArea": "Deliveries are available exclusively within Szczecin and Police.",
      "deliveryAreaDetails": "A detailed list of serviced locations can be found",
      "here": "here"
    },
    "api": {
      "errorMessage": "An error occurred while placing your order. Please try again later.",
      "createSuccess": "Your order has been placed successfully!",
      "updateSuccess": "Order has been updated successfully!",
      "deleteSuccess": "Order has been deleted!"
    }
  },

  "driver": {
    "cardTitles": {
      "driver": "Driver",
      "user": "User",
      "endingAddress": "Ending Address"
    },
    "formLabels": {
      "capacity": "Capacity (kg)",
      "maxOrderCount": "Maximum orders",
      "color": "Color",
      "colorPicker": "Choose color",
      "accountMode": "Account assignment",
      "account": "Existing account",
      "email": "Email",
      "password": "Password",
      "street": "Street",
      "buildingNumber": "Building Number",
      "apartmentNumber": "Apartment Number",
      "postalCode": "Postal Code",
      "city": "City",
      "streetName": "Street Name"
    },
    "formHints": {
      "accountPlaceholder": "Select an account by email",
      "accountsLoading": "Loading accounts...",
      "noAccounts": "No available accounts"
    },
    "accountModes": {
      "existing": "Select an existing account",
      "create": "Create a new account"
    },
    "api": {
      "createSuccess": "Driver has been created successfully!",
      "updateSuccess": "Driver has been updated successfully!",
      "deleteSuccess": "Driver has been deleted!"
    }
  },

  "blueberry": {
    "updateSuccess": "Price has been updated!",
    "updateError": "Something went wrong while updating the price."
  },
  "admin": {
    "common": {
      "yes": "Yes",
      "no": "No",
      "unknown": "Unknown"
    },
    "nav": {
      "dashboard": "Dashboard",
      "login": "Login",
      "home": "Home",
      "orders": "Orders",
      "routes": "Routes",
      "drivers": "Drivers",
      "analytics": "Analytics",
      "history": "History",
      "settings": "Settings"
    },
    "topbar": {
      "toggleMenu": "Toggle menu",
      "toggleUserMenu": "Toggle user menu",
      "searchPlaceholder": "Search orders...",
      "searchingOrders": "Searching orders...",
      "noOrdersFound": "No orders found",
      "searchError": "Orders could not be searched",
      "showingFirstOrders": "Showing the first {count} of {total} orders",
      "myAccount": "My account",
      "settings": "Settings",
      "logout": "Logout"
    },
    "table": {
      "refreshAndClearFilters": "Refresh and clear filters",
      "import": "Import",
      "export": "Export",
      "importSuccess": "Import completed successfully.",
      "importError": "Import failed.",
      "exportSuccess": "Export completed successfully.",
      "exportError": "Export failed.",
      "searchAllColumns": "Search all columns...",
      "noResults": "No results",
      "selectAll": "Select all",
      "selectRow": "Select row",
      "filterByDate": "Filter by date",
      "filterByType": "Filter by type",
      "allTypes": "All types",
      "typeDelivery": "Delivery",
      "typePickup": "Pickup",
      "filterByStatus": "Filter by status",
      "filterByPaymentStatus": "Filter by payment status",
      "filterByDriver": "Filter by driver",
      "allDrivers": "All drivers",
      "filterByConfidence": "Filter by confidence",
      "allConfidenceLevels": "All confidence levels",
      "lowConfidence": "Low confidence",
      "filterByLocationType": "Filter by address type",
      "allLocationTypes": "All address types",
      "officeOrders": "Office",
      "apartmentAddresses": "Apartment",
      "houseAddresses": "House",
      "otherAddresses": "Other",
      "filterByComment": "Filter by description",
      "allComments": "All descriptions",
      "withComment": "With description",
      "withoutComment": "Without description",
      "allStatuses": "All statuses",
      "statusOr": "or",
      "allPaymentStatuses": "All payment statuses",
      "statusPending": "Pending",
      "statusProcessing": "Processing",
      "statusShipped": "Shipped",
      "statusDelivered": "Delivered",
      "statusCancelled": "Cancelled",
      "statusReturned": "Returned"
    },
    "pagination": {
      "showingRows": "Showing {count} {label}.",
      "row": "row",
      "rows": "rows",
      "rowsPerPage": "Rows per page",
      "pageOf": "Page {page} of {total}",
      "goFirst": "Go to first page",
      "goPrevious": "Go to previous page",
      "goNext": "Go to next page",
      "goLast": "Go to last page"
    },
    "home": {
      "allOrders": "All Orders",
      "ordersFrom": "Orders from BorowkaSzczecin."
    },
    "analytics": {
      "window": "Window",
      "today": "Today",
      "last7d": "Last 7 days",
      "last30d": "Last 30 days",
      "custom": "Custom",
      "start": "Start",
      "end": "End",
      "refreshKpis": "Refresh KPIs",
      "apiHealthSectionTitle": "API health",
      "apiHealthSectionSubtitle": "Server failures and throttling in the selected window.",
      "googleSectionTitle": "Google performance",
      "googleSectionSubtitle": "Google Search and website traffic in the selected window.",
      "googleUnavailable": "Some Google data is unavailable. Check the integration credentials and property permissions.",
      "cards": {
        "ordersTitle": "Orders",
        "ordersSubtitle": "Total in selected window",
        "pendingTitle": "Pending Orders",
        "pendingSubtitle": "Awaiting processing",
        "deliveredTitle": "Delivered Orders",
        "deliveredSubtitle": "Completed deliveries",
        "revenueTitle": "Revenue",
        "revenueSubtitle": "Orders and additional route sales",
        "soldKgTitle": "Kilograms sold",
        "soldKgSubtitle": "Orders excluding cancellations and returns, plus additional route sales",
        "extraSoldKgTitle": "Additional kilograms sold",
        "extraSoldKgSubtitle": "Additional blueberries sold by drivers on their routes",
        "mixTitle": "Order Type Mix",
        "mixSubtitle": "Delivery / Pickup",
        "averageTitle": "Average Order Value",
        "averageSubtitle": "Per order in selected window",
        "abandonedFormsTitle": "Abandoned Forms",
        "abandonedFormsSubtitle": "No activity or order for at least {minutes} minutes",
        "apiErrorsTitle": "API Error Rate",
        "apiErrorsSubtitle": "HTTP 5xx responses (count and rate)",
        "throttledRequestsTitle": "Throttled Requests",
        "throttledRequestsSubtitle": "HTTP 429 responses in selected window",
        "searchClicksTitle": "Google Search Clicks",
        "searchImpressionsTitle": "Google Search Impressions",
        "searchCtrTitle": "Search CTR",
        "searchPositionTitle": "Average Search Position",
        "searchConsoleSubtitle": "Google Search Console",
        "activeUsersTitle": "Active Website Users",
        "sessionsTitle": "Website Sessions",
        "googleAnalyticsSubtitle": "Google Analytics (consented traffic)"
      }
    },
    "orders": {
      "deliveryOrders": "Delivery Orders",
      "deliverySubtitle": "Today's delivery orders from BorowkaSzczecin.",
      "deliverySubtitleForDate": "Processing delivery orders for {date}.",
      "pickupOrders": "Pickup Orders",
      "pickupSubtitle": "Today's pickup orders from BorowkaSzczecin.",
      "accept": "Accept",
      "cancel": "Cancel",
      "selectedCount": "{count} selected",
      "massAction": "Mass action",
      "massActionTitle": "Mass action for selected orders",
      "massActionDescription": "Choose an order status, preferred day, payment status, or any combination to apply to {count} selected orders.",
      "orderStatus": "Order status",
      "paymentStatus": "Payment status",
      "preferredDay": "Preferred day",
      "setPreferredDay": "Set preferred day",
      "clearPreferredDay": "Clear preferred day",
      "leaveUnchanged": "Leave unchanged",
      "paymentStatusUnknown": "Unknown",
      "paymentStatusUnpaid": "Unpaid",
      "paymentStatusAwaiting": "Awaiting payment",
      "paymentStatusPaid": "Paid",
      "paymentStatusFailed": "Failed",
      "applyMassAction": "Apply changes",
      "massActionApplying": "Applying...",
      "massUpdateSuccess": "Selected orders updated successfully",
      "massUpdateError": "Failed to update all selected orders",
      "statusUpdatedSuccess": "Order status changed successfully",
      "statusUpdatedError": "Failed to change order status",
      "routeUpdatedSuccess": "Route updated successfully",
      "routeCreatedSuccess": "Route created successfully",
      "routeCreateError": "Error creating route"
    },
    "quickOrder": {
      "button": "Quick order",
      "title": "Quick order entry",
      "quantity": "Quantity",
      "street": "Street",
      "streetSearchPlaceholder": "Search near your current location",
      "buildingNumber": "Building no.",
      "apartmentNumber": "Apartment no.",
      "city": "City",
      "district": "District",
      "phone": "Phone number",
      "assignedDriver": "Driver",
      "clearAssignedDriver": "Clear assigned driver",
      "blik": "BLIK",
      "blikPaid": "Mark as paid with BLIK",
      "note": "Description",
      "action": "Action",
      "add": "Add",
      "adding": "Adding...",
      "clear": "Clear",
      "keyboardHint": "Use Tab to move between fields and Enter to add the order.",
      "createSuccess": "Order added. Ready for the next one.",
      "createError": "The quick order could not be added.",
      "mapTitle": "Orders map",
      "mapDrivers": "Drivers:",
      "mapStatuses": "Status:",
      "unassignedDriver": "No driver",
      "mapEmpty": "No orders with a map position for this day.",
      "mapLoadError": "The orders map could not be loaded.",
      "mapMissingGeolocation": "{count} order has no map position. | {count} orders have no map position.",
      "enteredAddress": "Entered address",
      "usePin": "Use pin"
    },
    "orderDetails": {
      "title": "Order details",
      "orderId": "Order ID",
      "copyOrderId": "Copy order ID",
      "date": "Date",
      "delivery": "Delivery",
      "pickup": "Pickup",
      "sectionOrderDetails": "Order details",
      "subtotal": "Subtotal",
      "shipping": "Shipping",
      "tax": "Tax",
      "total": "Total",
      "shippingInfo": "Shipping information",
      "driver": "Driver",
      "pickupTime": "Pickup time",
      "preferredDeliveryTime": "Preferred delivery time",
      "comment": "Description",
      "customerInfo": "Customer information",
      "customer": "Customer",
      "email": "Email",
      "phone": "Phone",
      "openInGoogleMaps": "Open in Google Maps",
      "editGeolocation": "Edit map position",
      "editGeolocationHint": "Click the map button to correct this position.",
      "missingGeolocationWarningTitle": "Map position is missing",
      "missingGeolocationWarningDescription": "Click to search for the address or place the pin manually.",
      "geolocationEditorTitle": "Edit map position",
      "geolocationEditorDescription": "Search for an address, select a suggestion, or click the Leaflet map to place the pin. You can also drag the pin before saving.",
      "storedAddress": "Order address",
      "addressSearchLabel": "Search for an address",
      "addressSearchPlaceholder": "Street, building number, postal code, city",
      "searchAddress": "Search",
      "searchingAddress": "Searching...",
      "noAddressSearchResults": "No matching addresses were found.",
      "addressSearchError": "The address search is currently unavailable.",
      "mapPosition": "Pin position",
      "addressMapPreviewEmpty": "Search for and select an address to see its position on the map.",
      "mapPositionHint": "Click the map or drag the pin to make a precise correction.",
      "selectedCoordinates": "Selected coordinates",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "cancelGeolocationEdit": "Cancel",
      "saveGeolocation": "Save position",
      "savingGeolocation": "Saving...",
      "geolocationSaved": "Map position saved.",
      "geolocationSaveError": "The map position could not be saved.",
      "geocodingWarningTitle": "Check the map pin",
      "geocodingWarningDescription": "Geoapify did not fully match this address or one of its confidence scores is below {threshold}.",
      "geocodingConfidenceOverall": "Overall confidence",
      "geocodingConfidenceCity": "City confidence",
      "geocodingConfidenceStreet": "Street confidence",
      "geocodingConfidenceBuilding": "Building confidence",
      "geocodingMatchType": "Match type",
      "geocodingResultType": "Matched level",
      "geocodingMatchTypes": {
        "fullMatch": "Full match",
        "innerPart": "Inner part of the address",
        "byBuilding": "Matched by building",
        "byStreet": "Matched by street",
        "byPostcode": "Matched by postal code",
        "byCityOrDistrict": "Matched by city or district",
        "byCountryOrState": "Matched by country or state"
      },
      "geocodingResultTypes": {
        "building": "Building",
        "street": "Street",
        "postcode": "Postal code",
        "district": "District",
        "city": "City",
        "county": "County",
        "state": "State",
        "country": "Country"
      },
      "paymentInfo": "Payment information",
      "status": "Status",
      "method": "Method",
      "updated": "Updated"
    },
    "orderCards": {
      "createTitle": "Create Order",
      "createDescription": "Manually create an order",
      "createButton": "Create Order",
      "driversTitle": "Drivers",
      "driversDescription": "Select drivers, choose a date, and preview route readiness.",
      "driversLabel": "Drivers",
      "routeDateLabel": "Route date",
      "selectDriver": "Select Driver",
      "noDriverFound": "No driver found.",
      "showRoute": "Show Route",
      "createRoute": "Create Route",
      "previewRoute": "Preview Route",
      "previewRouteLoading": "Loading preview...",
      "deliveryWeightTitle": "Delivery weight",
      "deliveryWeightDescription": "Total weight of processing delivery orders for {date}.",
      "pickupWeightTitle": "Pickup weight",
      "pickupWeightDescription": "Total weight of processing pickup orders for {date}.",
      "filteredWeightTitle": "Order weight",
      "filteredWeightDescription": "Total weight of orders matching the table filters.",
      "orderCount": "{count} order | {count} orders",
      "dailyWeightSelectDate": "Select a date to see the weight of processing orders.",
      "dailyWeightLoading": "Calculating order weight...",
      "dailyWeightError": "Order weight could not be loaded.",
      "categorySummaryTitle": "Order summary",
      "categorySummaryPendingDescription": "Pending orders by category.",
      "categorySummaryProcessingDescription": "Processing orders by category.",
      "categorySummaryLoading": "Loading order summary...",
      "categorySummaryError": "The order summary could not be loaded.",
      "officeOrders": "Office",
      "ordersWithComment": "With description",
      "pickupOrders": "Pickup",
      "unsettledRoutesTitle": "Unsettled routes",
      "unsettledRoutesDescription": "Routes containing skipped points that still need settlement.",
      "unsettledRoutesLoading": "Loading unsettled routes...",
      "unsettledRoutesError": "The number of unsettled routes could not be loaded.",
      "routeCount": "route | routes",
      "settleRoutes": "Settle",
      "blueberryPriceTitle": "Blueberry price",
      "blueberryPriceDescription": "Update current blueberry price",
      "currentPrice": "Current price",
      "updatePrice": "Update Price"
    },
    "drivers": {
      "createTitle": "Create Driver",
      "createDescription": "Create new driver",
      "createButton": "Create Driver",
      "tableTitle": "Drivers",
      "tableSubtitle": "Your drivers fleet",
      "selectDriver": "Select a Driver",
      "driversLabel": "Drivers",
      "saveDistricts": "Save",
      "districtsSaveSuccess": "Districts saved successfully",
      "districtsSaveError": "Error saving districts",
      "detailsTitle": "Driver details",
      "detailsDescription": "Detailed information about driver.",
      "driverId": "Driver ID",
      "copyDriverId": "Copy driver ID",
      "endingAddress": "Ending address",
      "driverInfo": "Driver information",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "capacity": "Capacity",
      "maxOrderCount": "Maximum orders",
      "unlimited": "Unlimited",
      "userInfo": "User information",
      "districts": "Districts",
      "dateJoined": "Date joined",
      "dialog": {
        "updateTitle": "Update Driver",
        "createTitle": "Create new Driver",
        "updateDescription": "Update Driver. Click update when you're done.",
        "createDescription": "Create Driver. Click save when you're done.",
        "updateButton": "Update",
        "saveButton": "Save"
      }
    },
    "routes": {
      "title": "Routes",
      "subtitle": "Your routes",
      "previewTitle": "Route preview",
      "eligibleOrders": "Eligible orders",
      "missingGeolocation": "Missing geolocation",
      "optimizationRules": "Optimization rules",
      "enforceCapacity": "Enforce capacity",
      "enforceCapacityHint": "Respect the vehicle weight limit.",
      "enforceOrderCount": "Enforce order count",
      "enforceOrderCountHint": "Respect the driver's maximum order count.",
      "enforceDistrictSkills": "Enforce districts",
      "enforceDistrictSkillsHint": "Assign orders without a manually selected driver only to drivers serving their district.",
      "enforceAssignedDriver": "Enforce order driver",
      "enforceAssignedDriverHint": "Do not move an order to a driver other than the one selected in its Driver field.",
      "preserveDriverAssignments": "Preserve current assignments",
      "preserveDriverAssignmentsHint": "Keep orders with their current driver and only reorder stops.",
      "proposedRoutesMapEmpty": "No proposed route points are available to show on the map yet.",
      "dropOrdersHere": "Drop orders here",
      "unassignedOrders": "Unassigned orders",
      "capacityViolations": "Capacity violations",
      "excludedOrders": "Excluded orders",
      "emptySection": "Nothing to show here.",
      "remainingCapacity": "{value} kg free",
      "overCapacity": "{value} kg over",
      "routeOrderCount": "{count} / {max} orders",
      "routeOrderCountUnlimited": "{count} orders / unlimited",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "latitudePlaceholder": "53.4285",
      "longitudePlaceholder": "14.5528",
      "saveCoordinates": "Save coordinates",
      "savingCoordinates": "Saving...",
      "coordinatesSavedSuccess": "Coordinates saved successfully",
      "coordinatesSavedError": "Failed to save coordinates",
      "createRoutes": "Create routes",
      "creatingRoutes": "Creating routes...",
      "reoptimizeRoutes": "Reoptimize routes",
      "reoptimizingRoutes": "Reoptimizing...",
      "reoptimizeRoutesError": "Failed to reoptimize routes",
      "addOrder": "Add order to route",
      "addOrderSuccess": "The order was added and the remaining route was reoptimized",
      "addOrderError": "Failed to add the order to the route",
      "reportAction": "Report",
      "reportTitle": "Completed route report",
      "reportDescription": "Driver: {driver} · Date: {date}",
      "reportTakenKg": "Taken on route",
      "reportOrderSoldKg": "Sold from orders",
      "reportExtraSoldKg": "Extra sold",
      "reportTotalSoldKg": "Total sold",
      "reportRevenue": "Revenue",
      "reportDuration": "Route duration",
      "reportTimeline": "Route timeline",
      "reportTimelineDescription": "Points are ordered by their actual visit time.",
      "reportPoint": "Point",
      "reportPointNumber": "Point {number}",
      "reportAddress": "Address",
      "reportVisitedAt": "Visited at",
      "reportTimeFromPrevious": "From previous point",
      "reportRouteStart": "Route start",
      "reportNoVisitedPoints": "There are no visited points to display.",
      "createRoutesSuccess": "Routes created successfully",
      "createRoutesError": "Failed to create routes",
      "previewError": "Failed to load route preview",
      "unroutableOrdersTitle": "The route engine cannot find a route to these addresses",
      "unroutableOrdersDescription": "Correct the address location or delete the order, then try creating the route again.",
      "unroutableOrdersTableTitle": "Orders with unreachable addresses",
      "unroutableOrdersLoadError": "Failed to load orders with unreachable addresses",
      "clearDraft": "Clear routes",
      "clearingDraft": "Clearing routes...",
      "draftSaveError": "Failed to save the route preview",
      "draftLoadError": "Failed to restore the route preview",
      "draftClearSuccess": "Saved route preview cleared",
      "draftClearError": "Failed to clear the route preview",
      "reasonWrongDate": "Excluded because the preferred date does not match",
      "reasonMissingAddress": "Excluded because the order has no address",
      "unassignedCapacityOrConstraints": "The optimizer could not assign this order.",
      "unassignedOrderTooHeavy": "This order is heavier than any selected driver capacity.",
      "unassignedDriverNotSelected": "The driver assigned to this order was not selected for route planning.",
      "violationTotalCapacityExceeded": "Total route demand exceeds selected driver capacity.",
      "violationRouteCapacityExceeded": "Proposed load exceeds driver capacity for {driver}.",
      "violationOrderTooHeavy": "Order #{orderId} exceeds the largest selected driver capacity.",
      "capacityViolationSummary": "Load: {load} kg, capacity: {capacity} kg, overflow: {overflow} kg.",
      "detailsTitle": "Route",
      "copyDriverLink": "Copy driver link",
      "copyDriverLinkSuccess": "Driver link copied",
    "copyDriverLinkError": "Failed to copy the driver link",
    "driverPortalTitle": "Driver routes",
    "driverRoutesTitle": "Your routes",
    "noAssignedRoutes": "You do not have any assigned routes yet.",
    "routeDate": "Route date",
    "statusNotStarted": "Not started",
    "statusInProgress": "In progress",
    "statusCompleted": "Completed",
    "statusUnsettled": "Unsettled",
    "durationLessThanMinute": "less than 1 min",
    "durationMinutes": "{minutes} min",
    "durationHours": "{hours} hr",
    "durationHoursMinutes": "{hours} hr {minutes} min",
    "backToRoutes": "Back to routes",
    "driverRouteLoading": "Loading route...",
      "driverRouteError": "Failed to load the route.",
      "routePoints": "Route points",
      "googleMapsRoutes": "Routes in Google Maps",
      "googleMapsRouteSegment": "Route {number}: {start}–{end}",
    "totalAmount": "Total amount (kg)",
      "plannedLoad": "Planned for the route",
      "loadedAmount": "Blueberries loaded",
      "loadedAmountInvalid": "Enter a whole number of kilograms no lower than the planned route load.",
      "loadedAmountSaveSuccess": "The route load was saved",
      "loadedAmountSaveError": "Failed to save the route load",
      "extraSoldAmount": "Extra blueberries sold",
      "extraSoldAmountInvalid": "Enter a whole number of kilograms, at least 0.",
      "extraSoldAmountSaveSuccess": "The extra blueberry sales were saved",
      "extraSoldAmountSaveError": "Failed to save the extra blueberry sales",
      "currentDriverLoad": "Currently with driver",
    "exportAmount": "Amount",
    "descriptionPresent": "Yes",
    "descriptionAbsent": "No",
      "deliveryTime": "Delivery time",
      "orderPreviewTitle": "Order preview",
      "orderPreviewLoading": "Loading order details...",
      "orderPreviewError": "Failed to load order details.",
      "routeMap": "Route map",
      "routeMapLegend": "Route point status legend",
      "routeMapPending": "Pending",
      "routePointNext": "Next",
      "routeMapVisited": "Visited",
      "routeMapSkipped": "Skipped",
      "routeMapEmpty": "No route points with valid coordinates are available to show on the map.",
      "markVisited": "Visited",
      "markSkipped": "Skipped",
      "editRouteOrder": "Edit order",
      "editingRouteOrder": "Editing stop order",
      "movePointUp": "Move route point up",
      "movePointDown": "Move route point down",
      "reorderSuccess": "Route point order was saved",
      "reorderError": "Failed to save the route point order",
      "visitedPaymentTitle": "Record delivery payment",
      "visitedPaidCash": "Paid with cash",
      "visitedPaidBlik": "Paid with BLIK",
      "navigate": "Navigate",
      "nextRoutePoint": "Next point: {label}",
      "allRoutePointsCompleted": "All route points are completed",
      "continueProgress": "Continue",
      "undoProgress": "Undo",
      "addressNote": "Note",
      "addressNoteTitle": "Address notes",
      "customerOrderComment": "Customer order notes",
      "noCustomerOrderComment": "None",
      "driverAddressNote": "Driver note assigned to the address",
      "addressNotePlaceholder": "Enter information useful for the delivery",
      "addressNoteSaveSuccess": "The address note was saved",
      "addressNoteSaveError": "Failed to save the address note",
      "continueProgressSuccess": "Route point marked as visited",
      "continueProgressError": "Failed to continue to the next point",
      "undoProgressSuccess": "Last progress change undone",
      "undoProgressError": "Failed to undo the last change",
      "call": "Call",
      "markVisitedSuccess": "Route point marked as visited",
      "markVisitedError": "Failed to mark route point as visited",
      "markSkippedSuccess": "Route point marked as skipped",
      "markSkippedError": "Failed to mark route point as skipped",
      "finishRoundTitle": "Settle route",
      "skippedOrderBadge": "Skipped stop",
      "skippedOrderMeta": "Order #{orderId}",
      "resolveSkippedCancel": "Cancel order",
      "resolveSkippedProcessing": "Return to Processing",
      "resolveSkipped": "Resolve skipped orders",
      "resolvingSkipped": "Resolving skipped orders...",
      "resolveSkippedSuccess": "Skipped orders resolved successfully",
      "resolveSkippedError": "Failed to resolve skipped orders"
    },
    "history": {
      "title": "Audit history",
      "subtitle": "A permanent record of business data changes.",
      "entryCount": "Audit entries",
      "storageSize": "Retained data size",
      "search": "Search actor, event, resource, or ID...",
      "allSources": "All sources",
      "allActions": "All actions",
      "dateFrom": "From date",
      "dateTo": "To date",
      "resourceType": "Resource type",
      "applyFilters": "Apply filters",
      "clearFilters": "Clear filters",
      "timestamp": "Timestamp",
      "source": "Source",
      "actor": "Actor",
      "action": "Action",
      "resource": "Resource",
      "resourceIds": "Resource IDs",
      "changes": "Changes",
      "loading": "Loading audit history...",
      "automated": "Automated operation",
      "totalEntries": "{count} entries",
      "detailsTitle": "Audit entry details",
      "field": "Field",
      "before": "Before",
      "after": "After",
      "export": "Export CSV",
      "exportSuccess": "Audit history exported.",
      "exportError": "Audit history could not be exported.",
      "clear": "Clear all history",
      "clearTitle": "Clear the complete audit history?",
      "clearDescription": "This permanently removes every existing entry. A single receipt recording this action will remain.",
      "clearConfirmation": "Type CLEAR to confirm.",
      "clearSuccess": "Cleared {count} audit entries.",
      "clearError": "Audit history could not be cleared.",
      "sources": {
        "admin_api": "Admin dashboard",
        "django_admin": "Django admin",
        "customer": "Customer",
        "payment_provider": "Payment provider",
        "system": "System"
      },
      "actions": {
        "create": "Created",
        "update": "Updated",
        "delete": "Deleted",
        "import": "Imported",
        "export": "Exported",
        "clear": "Cleared"
      }
    },
    "columns": {
      "id": "ID",
      "name": "Name",
      "firstName": "First Name",
      "lastName": "Last Name",
      "phoneNumber": "Phone Number",
      "street": "Street",
      "buildingNumber": "Building Number",
      "apartmentNumber": "Apartment Number",
      "city": "City",
      "driver": "Driver",
      "status": "Status",
      "paymentStatus": "Payment Status",
      "mapOrder": "Point",
      "amountKg": "Amount (kg)",
      "type": "Type",
      "preferredDay": "Preferred Day",
      "preferredTime": "Preferred Time",
      "address": "Address",
      "actions": "Actions",
      "stops": "Stops",
      "routeDuration": "Duration",
      "createdAt": "Created At",
      "timestamp": "Timestamp",
      "visitedAt": "Visited at",
      "skipped": "Skipped",
      "driverName": "Driver name",
      "assigned": "Assigned",
      "notAssigned": "Not assigned",
      "district": "District"
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "confirmTitle": "Are you absolutely sure?",
      "confirmDescription": "This action will delete this item.",
      "deleteSuccess": "Successfully deleted",
      "deleteError": "Failed to delete"
    },
    "auth": {
      "login": "Login",
      "email": "Email",
      "password": "Password",
      "loginWithGoogle": "Login with Google",
      "loginFailed": "Login failed.",
      "googleLoginFailed": "Google login failed.",
      "redirectLoginFailed": "Redirect login failed.",
      "notWhitelisted": "You do not have an admin account.",
      "changePassword": "Change password",
      "changePasswordTitle": "Change password",
      "changePasswordDescription": "Enter your current password, then enter the new password twice.",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmNewPassword": "Confirm new password",
      "currentPasswordInvalid": "The current password is incorrect.",
      "newPasswordTooShort": "The new password must contain at least 12 characters.",
      "newPasswordsDoNotMatch": "The new passwords do not match.",
      "changePasswordTooManyRequests": "Too many attempts. Try again later.",
      "changePasswordSuccess": "Your password has been changed.",
      "changePasswordError": "The password could not be changed. Try again."
    },
    "settings": {
      "title": "Settings",
      "description": "Manage your admin preferences.",
      "currentLocale": "Current language",
      "languageEnglish": "English",
      "languagePolish": "Polish",
      "switchToEnglish": "Switch to English",
      "switchToPolish": "Switch to Polish",
      "seasonTitle": "Blueberry season",
      "seasonDescription": "Set the season dates, same-day ordering cutoff, and unavailable delivery dates.",
      "seasonOpeningDate": "Season opening date",
      "seasonClosingDate": "Season closing date",
      "seasonTransitionDate": "Date to switch to pre-season message",
      "sameDayOrderCutoffTime": "Same-day ordering cutoff",
      "blockedDeliveryDates": "Unavailable delivery dates",
      "blockedDeliveryDateAdd": "Block date",
      "blockedDeliveryDateRemove": "Remove blocked date {date}",
      "seasonCurrentStatus": "Current status",
      "seasonStatusLoading": "Loading",
      "seasonStatusUnknown": "Unknown",
      "seasonStatusOpen": "Ordering open",
      "seasonStatusBeforeStart": "Before season start",
      "seasonStatusAfterEnd": "After season end",
      "seasonSave": "Save ordering settings",
      "seasonSaveSuccess": "Ordering settings have been saved.",
      "seasonSaveError": "Could not save ordering settings.",
      "seasonValidationError": "Fix the ordering settings before saving.",
      "seasonOpeningRequired": "Season opening date is required.",
      "seasonClosingRequired": "Season closing date is required.",
      "seasonTransitionRequired": "Message transition date is required.",
      "sameDayOrderCutoffRequired": "Enter a valid same-day cutoff time.",
      "seasonTransitionBeforeOpening": "Message transition date must be on or before the season opening date.",
      "seasonOpeningBeforeClosing": "Season opening date must be on or before the season closing date.",
      "adminOrderEmailsTitle": "New-order email notifications",
      "adminOrderEmailsDescription": "Choose whether admin copies are sent when a new order is placed and manage their mailing list.",
      "adminOrderEmailsToggleLabel": "Send new-order emails to the admin mailing list",
      "adminOrderEmailRecipients": "Mailing list",
      "adminOrderEmailRecipientsPlaceholder": "admin{'@'}example.com\norders{'@'}example.com",
      "adminOrderEmailsSave": "Save email settings",
      "adminOrderEmailsSaving": "Saving...",
      "adminOrderEmailsSaveSuccess": "New-order email settings have been saved.",
      "adminOrderEmailsSaveError": "Could not save new-order email settings.",
      "adminOrderEmailsLoadError": "Could not load new-order email settings.",
      "adminOrderEmailRecipientsRequired": "Add at least one mailing-list address.",
      "adminOrderEmailRecipientsInvalid": "Enter only valid email addresses."
    }
  },
  "route": {
    "api": { "createSuccess": "Route has been created successfully!" }
  },
  "routePoints": {
    "api": { "updateSuccess": "Route point has been updated successfully!" }
  },
  "district": {
    "api": {
      "createSuccess": "Districts have been created successfully!",
      "updateSuccess": "Districts have been updated successfully!"
    }
  },
  "api": {
    "throttled": "Too many requests",
    "throttledDesc": "You are sending requests too quickly. Please wait a moment and try again.",
    "throttledDescWithRetry": "You are sending requests too quickly. Wait {seconds}s and try again.",
    "notFound": "Resource not found",
    "recaptchaFailed": "reCAPTCHA verification failed.",
    "unauthorized": "You are not authorized to perform this action.",
    "somethingWentWrong": "An error occurred while processing your request.",
    "unknown": "An unknown error occurred. Please try again later.",
    "invalidData": "Incorrectly formatted data."
  },

  "validation": {
    "field": {
      "required": "This field is required",
      "tooShort": "This field is too short",
      "tooLong": "This field is too long",
      "invalidEmail": "Please enter a valid email address"
    },
    "order": {
      "street_name": "Street is required",
      "city_name": "City is required",
      "postal_code": "Postal code is required",
      "postal_code_format": "Invalid postal code",
      "address_area_required": "Provide at least one of postal code, city, or district",
      "phone_prefix": "Number must start with + followed by a country code",
      "phone_digits_only": "Invalid phone number",
      "phone_too_short": "Phone number is too short",
      "phone_too_long": "Phone number is too long",
      "first_name": "First name is required",
      "last_name": "Last name is required",
      "location_type": "Select a valid location type",
      "preferred_date_past": "Date cannot be in the past",
      "preferred_date_required_all": "Please select a delivery date",
      "preferred_date_required": "Delivery date is required for office orders",
      "preferred_time_required": "Delivery time is required for office orders",
      "preferred_date_required_pickup": "Pickup date is required for pickup orders",
      "preferred_time_required_pickup": "Pickup time is required for pickup orders",
      "quantity_min": "Minimum quantity is 1 kg",
      "quantity_min_delivery": "Minimum quantity for delivery is 2 kg",
      "quantity_integer": "Invalid quantity"
    },
    "payment": {
      "method_required": "Choose a payment method"
    },
    "driver": {
      "color": "Enter a HEX color, for example #2563EB",
      "password": "The password must contain at least 12 characters"
    },
    "common": {
      "invalid": "Invalid input",
      "too_small": "Value is too small (minimum is {min})",
      "too_big": "Value is too large (maximum is {max})",
      "invalid_email": "Please provide a valid email.",
      "invalid_string": "Invalid text format.",
      "unrecognized_keys": "Unknown field(s) provided.",
      "invalid_type": "Invalid data format"
    }
  }
}
